<template>
    <div id="form_register" class="form-mobile">
        <div class="title">{{ lbl.register.title }}</div>
        <div class="row pt-2">
            <div class="col-sm-6 col-xs-12 desktop-padding-right">
                <InputText
                        v-model="registerModel.firstname"
                        inputId="register-firstname"
                        :inputLbl="lbl.register.firstname"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="true"
                        :errorInfo="errorInfo[0]"
                ></InputText>
            </div>
            <div class="col-sm-6 col-xs-12 desktop-padding-left">
                <InputText
                        v-model="registerModel.lastname"
                        inputId="register-lastname"
                        :inputLbl="lbl.register.lastname"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="true"
                        :errorInfo="errorInfo[1]"
                ></InputText>
            </div>
        </div>
        <div class="pt-2">
            <InputEmail
                v-model="registerModel.email"
                inputId="register-email"
                :inputLbl="lbl.register.email"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[2]"
            ></InputEmail>
        </div>
        <div class="pt-2">
            <InputContactNumber
                v-model="registerModel.contactNumber"
                inputId="register-contact-number"
                :inputLbl="lbl.register.mobileNumber"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[3]"
            ></InputContactNumber>
        </div>
        <div class="pt-2">
            <InputText
                v-model="registerModel.username"
                inputId="register-username"
                :inputLbl="lbl.register.username"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[4]"
            ></InputText>
        </div>
        <div class="pt-2">
            <InputPassword
                v-model="registerModel.password"
                inputId="register-password"
                :inputLbl="lbl.register.password"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :inputMaxLength="15"
                :inputMinLength="8"
                :errorInfo="errorInfo[5]"
            ></InputPassword>
        </div>
        <div class="pt-2">
            <InputPassword
                v-model="registerModel.confirmPassword"
                inputId="register-confirm-password"
                :inputLbl="lbl.register.confirmPassword"
                :isFirstSave="isFirstSave"
                :isShowErrorLbl="true"
                :inputMaxLength="15"
                :inputMinLength="8"
                :isNotMatchPassword="!checkPasswordNotMatch()"
                :errorInfo="errorInfo[6]"
            ></InputPassword>
        </div>
        <div class="pt-2">
            <Checkbox :textLbl="lbl.register.is_own_shop" :setValue="isOwn" @input="onCheckOwn($event)"></Checkbox>
        </div>
        <div v-if="isOwn">
            <div class="row pt-2">
                <div class="col-sm-6 col-xs-12 desktop-padding-right">
                    <InputNumber
                            v-model="registerModel.storeId"
                            inputId="register-storeId"
                            :inputLbl="lbl.register.storeId"
                            :isFirstSave="isFirstSaveOwn"
                            :isShowErrorLbl="isErrorOwn"
                            :errorInfo="errorInfo[7]"
                    ></InputNumber>
                </div>
                <div class="col-sm-6 col-xs-12 desktop-padding-left">
                    <InputText
                            v-model="registerModel.storeName"
                            inputId="register-storeName"
                            :inputLbl="lbl.register.storeName"
                            :isFirstSave="isFirstSaveOwn"
                            :isShowErrorLbl="isErrorOwn"
                            :errorInfo="errorInfo[8]"
                    ></InputText>
                </div>
            </div>
            <div class="pt-5 store-font">{{ lbl.register.storeType_title }}<span v-if="isShowError" class="require-input">{{ lbl.register.storeType_err }}</span></div>
            <div class="row pt-2 store-font">
                <div class="col-sm-6 col-xs-12 pr-2" v-for="(data,index) in registerModel.storeType" :key="index">
                    <Checkbox :textLbl="localeCode == 1033 ? data.textEN : data.textTH " :setValue="data.value" @input="onCheck(data,$event)"></Checkbox>
                </div>
            </div>
        </div>
        <div class="mt-4 text-center">
            <YellowButton @onClick="clickSubmit()">
                <span class="font-main register-text">{{ lbl.register.btn_register }}</span>
            </YellowButton>
        </div>
        <!-- <div class="account-already">
            Already have an account? <span class="login-text" @click="onClickLogin()">Log in</span>
        </div> -->
    </div>
</template>
<script>
import Locale from "@/helper/locale/Locale.js";
import FormHelper from "@/helper/FormHelper.js";
import InputText from "@/components/Input/Text.vue";
import InputPassword from "@/components/Input/Password.vue";
import InputContactNumber from "@/components/Input/ContactNumber.vue";
import InputEmail from "@/components/Input/Email.vue";
import Checkbox from '@/components/Input/CheckBox.vue';
import YellowButton from '@/components/Button/YellowButton.vue';
import InputNumber from '@/components/Input/Number.vue';
import { StoreTypeList } from '../model/RegisterModel'
import LocaleMixin from '@/mixin/LocaleMixin'
import Utility from "@/helper/Utility";
export default {
    name: "FormRegister",
    mixins: [LocaleMixin],
    props:{
        form: Object,
        modalController: Object
    },
    components: {
        InputText,
        InputPassword,
        InputContactNumber,
        InputEmail,
        Checkbox,
        YellowButton,
        InputNumber
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            isFirstSave: true,
            errorInfo: [],
            storeTypeList: new StoreTypeList(),
            registerModel :this.form,
            isShowError: false,
            isOwn: false,
            isFirstSaveOwn: false,
            isErrorOwn: false,
        };
    },
    created: function() {
        this.errorInfo = FormHelper.genErrorInfo(9);
        this.registerModel.storeType = this.storeTypeList;
    },
    methods: {
        clickSubmit: function() {
            this.isFirstSave = false;
            if (this.isOwn) {
                this.isFirstSaveOwn = false;
            }
            if (this.validateForm() && this.checkPasswordNotMatch() && this.validateInputCheckbox()) {
                let storeType = this.registerModel.storeType.filter(item => item.value)
                let brandIds = storeType.map(item => ({
                    store_id : item.id,
                    store_name : item.name,
                    store_type : this.localeCode == 1033 ? item.textEN : item.textTH
                }))
                this.registerModel.customInfo = {
                    StoreID: this.registerModel.storeId,
                    StoreName: this.registerModel.storeName,
                    StoreType: brandIds,
                }
                this.registerModel.customInfo = this.registerModel.customInfo ? JSON.stringify(this.registerModel.customInfo) : ''
                this.$emit("onSubmitRegister", this.registerModel);
            }
        },
        onClickLogin(){
            this.$emit('login');
        },
        onCheck: function(item,check){
            item.value = check;
            this.registerModel.storeType = this.storeTypeList;
            this.validateInputCheckbox();
        },
        validateForm: function() {
            if (this.registerModel.email != '') {
                let validateEmail = Utility.validateEmail(this.registerModel.email)
                if(!validateEmail){
                    this.errorInfo[2] = {
                        isValid: false,
                        msg: 'กรุณากรอกอีเมลให้ถูกต้อง'
                    }
                }
            }
            this.validateInputCheckbox();
            return FormHelper.validate(this.errorInfo);
        },
        checkPasswordNotMatch: function(){
            if(this.registerModel.password == this.registerModel.confirmPassword){
                return true;
            }else{
                return false;
            }
        },
        validateInputCheckbox: function(){
            if (!this.isOwn) {
                this.isShowError = false;
                return true;
            }
            let storeType = this.registerModel.storeType.filter(item => item.value)
            if(storeType.length){
                this.isShowError = false;
                return true
            }else{
                this.isShowError = true;
                return false
            }
        },
        onCheckOwn: function(check){
            this.isOwn = check;
            this.isFirstSaveOwn = check;
            this.isErrorOwn = check;
            this.errorInfo = FormHelper.genErrorInfo(9);
        },
    },
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '../page/Register.scss';
.desktop-padding-left{
    padding-left: 20px;
    @include mobile{
        padding-right: 15px;
        padding-left: 15px;
    }
}
.desktop-padding-right{
    padding-right: 20px;
    @include mobile{
        padding-right: 15px;
        padding-left: 15px;
    }
}
.require-input{
    font-size: 13px;
    color: #ff0000;
    transition-duration: 300ms;
}
.register-text{
    font-size: $px16;
}
.store-font{
    color: #4a4a4a;
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";

#form_register{
    .wrap-input{
        .input-box{
            .input-field{
                color: $a-black-333333;
            }
        }
    }
    .box-checkbox {
        .text-label-check{
            color: $a-black-333333;
        }
    }
}
</style>
